// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"64f6f074","774":"f6dfb0d6","787":"a074696d"}[chunkId] + ".chunk.js";
};